module.exports = __webpack_public_path__ + "static/img/sec2-img02@tw.21dd93e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ezwel-renewal/sec2-img02@tw.png
// module id = nRRG
// module chunks = 0